import { Navigate, Route, Routes, useNavigate } from 'react-router';
import { Trans } from '@lingui/react/macro';

import AlertBar from '@/design_system/AlertBar';
import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';

import { SettingsSectionLayout } from '../../../components/Layout/Layout';
import { type LegacySettingsLocationState } from '../../../legacy-settings';

const legacyTabs = {
  actions: '/settings?tab=actions',
  defects: '/settings?tab=defect-types',
  'spare-parts': '/settings?tab=spare-part-types',
} as const;

export const Services = () => {
  return (
    <SettingsSectionLayout
      title={<Trans id="settings-section.services">Services</Trans>}
      tabs={[
        {
          id: 'actions',
          label: <Trans id="settings.organization.data-catalogs.actions">Actions</Trans>,
        },
        {
          id: 'defects',
          label: <Trans id="settings.organization.data-catalogs.defects">Defects</Trans>,
        },
        {
          id: 'spare-parts',
          label: <Trans id="settings.organization.data-catalogs.spare-parts">Spare parts</Trans>,
        },
      ]}
    >
      <Routes>
        <Route path="" element={<Navigate to="/settings_beta/services/actions" replace />} />
        {Object.entries(legacyTabs).map(([tab, legacyHref]) => (
          <Route key={tab} path={tab} element={<LegacyBridge legacyHref={legacyHref} />} />
        ))}
        <Route path="*" element={<Navigate to="/settings_beta/services/actions" replace />} />
      </Routes>
    </SettingsSectionLayout>
  );
};

const LegacyBridge = ({ legacyHref }: { legacyHref: string }) => {
  const navigate = useNavigate();

  return (
    <AlertBar
      type="info"
      size="large"
      title={
        <Trans id="settings-section.services.legacy.title">
          This page is still managed in the legacy Settings
        </Trans>
      }
    >
      <Stack gap="0.75rem" alignItems="flex-start">
        <Trans id="settings-section.services.legacy.description">
          It will move here soon. In the meantime, you can view and edit it in the legacy Settings.
        </Trans>
        <Button
          variant="secondary"
          size="medium"
          onPress={() =>
            navigate(legacyHref, {
              state: { fromSettingsBeta: true } satisfies LegacySettingsLocationState,
            })
          }
        >
          <Trans id="settings-section.services.legacy.open">Open in legacy Settings</Trans>
        </Button>
      </Stack>
    </AlertBar>
  );
};
